import script from "./ClearCache.vue?vue&type=script&setup=true&lang=js"
export * from "./ClearCache.vue?vue&type=script&setup=true&lang=js"

import "./ClearCache.vue?vue&type=style&index=0&id=ee3ecfd2&lang=css"

const __exports__ = script;

export default __exports__